import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const modelUrl = process.env.REACT_APP_MODELPATH+"bathroommat.glb";

export default function BathroomMatModel(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(modelUrl);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object549.geometry}
        material={materials["Custom (3)"]}
      />
    </group>
  );
}

useGLTF.preload(modelUrl);